import Vue from "vue";
import App from "@/App.vue";
import LoadingScreen from "@/LoadingScreen.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import axios from "axios";

import loadingMixin from "@/mixins/loadingMixin";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi\\font/css/materialdesignicons.min.css";
import "@/styles/app.scss";
import filters from "@/filters";

Vue.config.productionTip = false;
// Vue.config.devtools = true;

// GLOBAL SETUP:
(async () => {
  try {
    // load the config.json file -- has API url in it:
    let response = await axios.get(process.env.BASE_URL + "config.json");
    const nexa_config = response.data;
    store.commit("initConfig", nexa_config);

    // Haven't figured out the API auth yet.
    axios.defaults.auth = {
      username: nexa_config.API_USERID,
      password: nexa_config.API_PASSWORD,
    };

    axios.defaults.baseURL = nexa_config.BASE_API;
    axios.defaults.headers.common["Cache-Control"] =
      "no-cache, no-store, must-revalidate";
    // (should probably handle error, but loading from same site shouldn't worry)
    axios
      .get(nexa_config.BASE_API + "/System/Config/MQ")
      .then((response) => {
        // merge with configurations from database
        store.commit("appendConfig", response.data);
        store.commit("setConfigLoaded", true);

        // ----- APP SETUP -----
        // Main statement creating App:
        // replaces the loading screen
        new Vue({
          router,
          store,
          vuetify,
          mixins: [loadingMixin],
          render: (h) => h(App),
        }).$mount("#app");

        // console.log(
        //   "%c NEXA MobileQ Version: " + process.env.VUE_APP_VERSION + " ",
        //   "background-color:#3ea3a6; color:black"
        // );
      })
      .catch((error) => {
        console.log(error); // TODO: handle error
      });
  } catch (e) {
    console.log("Error loading global:", e);
  }
})();

// Load all filters from filters.js
filters.forEach((f) => {
  Vue.filter(f.name, f.execute);
});

// Put up global loading screen first:
new Vue({
  vuetify,
  render: (h) => h(LoadingScreen),
}).$mount("#app");
